function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button, Empty, Input, AutoComplete, Row, Col, Space, Typography } from 'antd';
import { useRequest } from '@umijs/hooks';
import { SearchOutlined, SaveOutlined } from '@ant-design/icons';
import client from '../../../feathers';
import { StyledScenarioName } from './ScenarioName';
import { replaceDefaultValues } from '../_helpers';
import { renderItem, renderTitle, scenarioToFormValues, formToFormValues } from './_helpers';
import { ControlPanelWrapper } from './index.style';
import CreateScenario from '../CreateScenario';
import LoadingContainer from '../../../loading-container';

function getScenarios(_x) {
  return _getScenarios.apply(this, arguments);
}

function _getScenarios() {
  _getScenarios = _asyncToGenerator(function* (endpointId) {
    var query = {
      $eager: '[parameters]',
      endpointId,
      $sort: {
        likes: -1
      }
    };
    var params = {
      query
    };
    var scenarios = yield client.service('scenarios').find(params);
    return scenarios;
  });
  return _getScenarios.apply(this, arguments);
}

var ControlPanel = (_ref) => {
  var {
    form,
    initialScenarioId,
    endpoint: {
      endpointId,
      name: endpointName
    },
    isAdmin,
    handleScenarioChange
  } = _ref;
  var [scenarios, setScenarios] = useState([]);
  var [options, setOptions] = useState([]);
  var [currentScenario, setCurrentScenario] = useState(null);
  var [editable, setEditable] = useState(false);
  var [searchActive, setSearchActive] = useState(false);

  var onSelect = value => {
    var config = {
      scenario: () => {
        var scenario = JSON.parse(value);
        var {
          code,
          formValues
        } = scenarioToFormValues(scenario);
        handleScenarioChange(code, formValues);
        setSearchActive(false);
        setCurrentScenario(scenario);
      },
      form: () => {
        var scenario = JSON.parse(value);
        var {
          code,
          formValues
        } = formToFormValues(scenario);
        handleScenarioChange(code, formValues);
        setSearchActive(false);
        setCurrentScenario(scenario);
      }
    };
    return config.scenario();
  };

  var {
    data,
    error,
    loading
  } = useRequest(() => getScenarios(endpointId), {
    refreshDeps: [endpointId],
    onSuccess: (result, params) => {
      setScenarios(result.data);
      var o = [];
      result.data.forEach(scenario => {
        var {
          name,
          likes
        } = scenario;
        o.push(renderItem(scenario, name, likes));
      });
      setOptions([{
        label: renderTitle("".concat(endpointName, " Scenarios")),
        options: o
      }]);

      if (initialScenarioId) {
        var initialScenario = result.data.find(scenario => {
          var {
            scenarioId
          } = scenario;
          return scenarioId === _.toNumber(initialScenarioId);
        });

        if (initialScenario) {
          onSelect(JSON.stringify(initialScenario));
        }
      }
    }
  });

  if (searchActive && loading) {
    return /*#__PURE__*/React.createElement(LoadingContainer, null);
  }

  if (searchActive && error) {
    return /*#__PURE__*/React.createElement("div", null, "Error");
  }

  return /*#__PURE__*/React.createElement(ControlPanelWrapper, null, /*#__PURE__*/React.createElement(Row, {
    justify: "space-around",
    align: "middle"
  }, /*#__PURE__*/React.createElement(Col, {
    flex: "1"
  }, /*#__PURE__*/React.createElement(StyledScenarioName, {
    form: form,
    initialName: currentScenario && currentScenario.name,
    isAdmin: isAdmin,
    endpointId: endpointId,
    scenarios: scenarios,
    onSelect: onSelect
  })), /*#__PURE__*/React.createElement(Col, {
    flex: "0"
  }, /*#__PURE__*/React.createElement(Space, null, isAdmin && /*#__PURE__*/React.createElement(CreateScenario, {
    form: form,
    isAdmin: isAdmin,
    scenario: currentScenario
  }), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    type: searchActive && 'primary',
    icon: /*#__PURE__*/React.createElement(SearchOutlined, null),
    onClick: () => setSearchActive(!searchActive)
  })))), searchActive && /*#__PURE__*/React.createElement(AutoComplete, {
    defaultOpen: true,
    onSelect: onSelect,
    options: options,
    filterOption: true,
    notFoundContent: /*#__PURE__*/React.createElement(Empty, {
      image: Empty.PRESENTED_IMAGE_SIMPLE,
      description: "No scenarios found."
    })
  }, /*#__PURE__*/React.createElement(Input, {
    size: "small",
    placeholder: "Search scenarios..."
  })));
};

export default ControlPanel;